<div class="pt-3 pl-md-4" *ngIf="notFound">
  <h2>Association not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingAssociation">
  <h2>Loading Association...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to configure associations.
  </h2>
</div>

<div *ngIf="(serverError === null) && !notFound && !loadingAssociation && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a [routerLink]="['/associations', association.id.toString()]" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <!-- No internal navigation (yet) for associations -->
    </ul>

    <form class="form-inline">
      <button class="btn btn-danger btn-sm ml-2"
              [class.disabled]="loadingSubmit" [disabled]="loadingSubmit"
              type="button" (click)="openRemoveAssociationModal()">
        Remove Association
      </button>
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="loadingSubmit" [disabled]="loadingSubmit"
              type="button" (click)="handleSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 mb-6">
      <h2>
        Configure Association
      </h2>

      <form (submit)="handleSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8">

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="nameInput">Name</label>
                  <input id="nameInput" type="text" name="name"
                         class="form-control"
                         [(ngModel)]="association.name"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.name }}</div>
            </div>

            <div class="form-group">
              <label for="profileImageInput">Profile Image</label>
              <input id="profileImageInput" class="mb-2 d-block"
                     type="file" accept=".jpg,.jpeg,.png"
                     (change)="attachProfileImageFile($event)">
              <img *ngIf="!association.profile_image"
                   src="/assets/images/photo_placeholder.png"
                   alt="association profile image"
                   class="association-photo my-2">
              <img *ngIf="association.profile_image"
                   [src]="association.profile_image"
                   alt="association profile image"
                   class="association-photo my-2">
            </div>

            <div class="form-group">
              <label for="verificationReqsInput">Association Verification Requirements (optional)</label>
              <textarea id="verificationReqsInput" type="text" name="verification_requirements"
                        class="form-control"
                        [(ngModel)]="association.verification_requirements"
                        (ngModelChange)="unsavedChanges = true"></textarea>
              <small class="form-text text-muted">
                This information is displayed to staff when adding a customer to the association, re-verifying existing association members, and reviewing customer applications.
              </small>
              <div class="form-text text-danger">{{ errors.verification_requirements }}</div>
            </div>

            <div class="form-group">
              <label for="automaticRemovalSettingSelect">When does a customer's association membership expire?</label>
              <select class="custom-select"
                      id="automaticRemovalSettingSelect"
                      name="automaticRemovalSetting"
                      [(ngModel)]="automaticRemovalSetting"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="AutomaticRemovalSetting.whenManuallyRemoved">
                  When manually removed
                </option>
                <option [ngValue]="AutomaticRemovalSetting.afterSetInterval">
                  After a set interval
                </option>
                <option [ngValue]="AutomaticRemovalSetting.onSetDates">
                  On set dates
                </option>
              </select>
              <small class="form-text text-muted">
                Customers may be manually removed from an association at any time, regardless of the selected option. For automatic expirations, a re-verification window may be additionally configured (see below).
              </small>
            </div>

            <div *ngIf="automaticRemovalSetting !== AutomaticRemovalSetting.whenManuallyRemoved"
                 class="indented-subsection">

              <div class="form-group" *ngIf="automaticRemovalSetting === AutomaticRemovalSetting.afterSetInterval">
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <label for="autoRemovalIntervalMonthsInput">Association membership expiration interval (months)</label>
                    <input class="form-control" id="autoRemovalIntervalMonthsInput"
                           type="number" min="1" step="1" required
                           name="automatic_removal_interval_months"
                           [(ngModel)]="association.automatic_removal_interval_months"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <div class="form-text text-danger">{{ errors.automatic_removal_interval_months }}</div>
              </div>

              <div class="form-group" *ngIf="automaticRemovalSetting === AutomaticRemovalSetting.onSetDates">
                <label>Membership expiration days</label>

                <div *ngFor="let date of association.automatic_removal_dates; let idx = index;">

                  <div class="form-group">
                    <div class="row">
                      <div class="col-8">
                        <input class="form-control disabled"
                               disabled
                               [value]="dateStringFromISO8601(date)">
                      </div>
                      <div class="col-4">
                        <button class="btn btn-danger" type="button"
                                (click)="association.automatic_removal_dates.splice(idx, 1); unsavedChanges = true; $event.preventDefault();">
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>

                </div>

                <div *ngIf="association.automatic_removal_dates.length === 0">
                  <p class="text-muted">
                    No Days
                  </p>
                </div>

                <div class="form-group">
                  <div class="row">
                    <div class="col-8">
                      <app-date-picker [id]="'automaticRemovalDateToAdd'"
                                       [(content)]="automaticRemovalDateToAdd"></app-date-picker>
                    </div>
                    <div class="col-4">
                      <button class="btn btn-success" type="button"
                              (click)="association.automatic_removal_dates.push(automaticRemovalDateToAdd); unsavedChanges = true; $event.preventDefault();">
                        Add Date
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-text text-danger">{{ errors.automatic_removal_dates }}</div>
              </div>

              <div class="form-group">
                <label for="reverificationPeriodDaysInput">
                  Association membership re-verification period (days, optional)
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input class="form-control" id="reverificationPeriodDaysInput"
                           type="number" min="1" step="1"
                           name="reverification_period_days"
                           [(ngModel)]="association.reverification_period_days"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <div class="form-text text-danger">{{ errors.reverification_period_days }}</div>
                <small class="form-text text-muted">
                  If a re-verification period is configured, a customer may be re-verified before their association membership expires, preventing them from being removed from the association.
                </small>
              </div>

              <div class="form-group">
                <label for="showReverificationAlertSelect">Should an alert be added to customers' accounts when they need to re-verify?</label>
                <select class="custom-select"
                        id="showReverificationAlertSelect"
                        name="show_reverification_alert"
                        [(ngModel)]="association.show_reverification_alert"
                        (ngModelChange)="unsavedChanges = true">
                  <option [ngValue]="true">Yes</option>
                  <option [ngValue]="false">No</option>
                </select>
                <div class="form-text text-danger">{{ errors.show_reverification_alert }}</div>
                <small class="form-text text-muted">
                  During the re-verification period, this alert will appear on a customer's Staff Site profile, as well as when they check in.
                </small>
              </div>

            </div>

            <div class="form-group">
              <label for="membershipExpirationAgeInput">
                Association membership expiration age (optional)
              </label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <input class="form-control" id="membershipExpirationAgeInput"
                         type="number" min="1" step="1"
                         name="membership_expiration_age"
                         [(ngModel)]="association.membership_expiration_age"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.membership_expiration_age }}</div>
              <small class="form-text text-muted">
                If an expiration age is configured, a customer will automatically be removed from the association when they reach that age, regardless of any other expiration settings. For example, if this is set to "18", then a customer will be removed from the association on their 18th birthday.
                <br>
                <span class="text-danger">Please note that when this value is set, any existing association members at or above the configured age will be automatically removed within an hour.</span>
              </small>
            </div>

            <div class="form-group">
              <label for="allowAutomaticEntryPassUseSelect">Should entry passes owned by this association be used by association members on check-in?</label>
              <select class="custom-select"
                      id="allowAutomaticEntryPassUseSelect"
                      name="allow_automatic_entry_pass_use"
                      [(ngModel)]="association.allow_automatic_entry_pass_use"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ errors.allow_automatic_entry_pass_use }}</div>
              <small class="form-text text-muted">
                If this is set to "Yes", then association entry passes may be used for entry at any time by members of the association. If "No", then association entry passes will only be used when an association member is checked in directly from the Association Profile's Association Members list. This is useful for school groups or partners that only want association members using the entry passes at certain times.
              </small>
            </div>

            <div class="form-group">
              <label for="allowCustomerApplicationsSelect">Can customers request to be added to this association using the Climber App?</label>
              <select class="custom-select"
                      id="allowCustomerApplicationsSelect"
                      name="allow_customer_applications"
                      [(ngModel)]="association.allow_customer_applications"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ errors.allow_customer_applications }}</div>
              <small class="form-text text-muted">
                If this is set to "Yes", then the association will be listed publicly in the Climber App, where any customer may request to be added to the association.
                <br>
                Once requested, the customer's association membership will be in a pending state until approved by staff. While pending, the customer has access to the association's discounts, if any are configured. The customer will not be able to check into any location until their request has been approved or denied. If denied, any purchases made using an association discount will automatically be cancelled and refunded.
              </small>
            </div>

            <div *ngIf="association.allow_customer_applications"
                 class="indented-subsection">

              <div class="form-group">
                <label for="applicationDocumentFieldConfigSelect">
                  Are customers asked to upload a document image as part of their request to join the association?
                </label>
                <select class="custom-select"
                        id="applicationDocumentFieldConfigSelect"
                        name="application_document_field_config"
                        [(ngModel)]="association.application_document_field_config"
                        (ngModelChange)="unsavedChanges = true">
                  <option [ngValue]="ApplicationFieldConfig.none">
                    No
                  </option>
                  <option [ngValue]="ApplicationFieldConfig.optional">
                    Yes, optional
                  </option>
                  <option [ngValue]="ApplicationFieldConfig.required">
                    Yes, required
                  </option>
                </select>
                <div class="form-text text-danger">{{ errors.application_document_field_config }}</div>
                <small class="form-text text-muted">
                  If "Yes", an image file upload will be shown when a customer requests to join the association. Use the "Association membership application instructions" field to tell the customer what information should be provided.
                </small>
              </div>

              <div class="form-group" *ngIf="association.application_document_field_config !== ApplicationFieldConfig.none">
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <label for="applicationDocumentFieldNameInput">
                      Document Image Upload Field Name (optional)
                    </label>
                    <input id="applicationDocumentFieldNameInput" type="text"
                           name="application_document_field_name"
                           class="form-control"
                           placeholder="Document Image Upload"
                           [(ngModel)]="association.application_document_field_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <div class="form-text text-danger">{{ errors.application_document_field_name }}</div>
                <small class="form-text text-muted">
                  This name will be displayed above the document image upload input button in the Climber App.
                </small>
              </div>

              <div class="form-group">
                <label for="applicationTextFieldConfigSelect">
                  Are customers asked to provide text as part of their request to join the association?
                </label>
                <select class="custom-select"
                        id="applicationTextFieldConfigSelect"
                        name="application_text_field_config"
                        [(ngModel)]="association.application_text_field_config"
                        (ngModelChange)="unsavedChanges = true">
                  <option [ngValue]="ApplicationFieldConfig.none">
                    No
                  </option>
                  <option [ngValue]="ApplicationFieldConfig.optional">
                    Yes, optional
                  </option>
                  <option [ngValue]="ApplicationFieldConfig.required">
                    Yes, required
                  </option>
                </select>
                <div class="form-text text-danger">{{ errors.application_text_field_config }}</div>
                <small class="form-text text-muted">
                  If "Yes", an input text box will be shown when a customer requests to join the association. Use the "Climber App Association Description and Requirements" field to tell the customer what information should be provided.
                </small>
              </div>

              <div class="form-group" *ngIf="association.application_text_field_config !== ApplicationFieldConfig.none">
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <label for="applicationTextFieldNameInput">
                      Text Input Field Name (optional)
                    </label>
                    <input id="applicationTextFieldNameInput" type="text"
                           name="application_text_field_name"
                           class="form-control"
                           placeholder="Supporting Text"
                           [(ngModel)]="association.application_text_field_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <div class="form-text text-danger">{{ errors.application_text_field_name }}</div>
                <small class="form-text text-muted">
                  This name will be displayed above the text input field in the Climber App.
                </small>
              </div>

              <div class="form-group">
                <label>Climber App Association Description and Requirements (optional)</label>
                <app-markdown-editor [id]="'applicationCustomerInstructionsInput'"
                                     [(content)]="association.application_customer_instructions"
                                     (contentChange)="unsavedChanges = true"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This information is displayed to customers when requesting to be added to the association.
                </small>
                <div class="form-text text-danger">{{ errors.application_customer_instructions }}</div>
              </div>

            </div>

            <div class="form-group">
              <label for="hasAutoAddOnBookingEventsSelect">Automatically add customers to this association after they are booked onto an event</label>
              <select class="custom-select"
                      id="hasAutoAddOnBookingEventsSelect"
                      name="hasAutoAddOnBookingEvents"
                      [(ngModel)]="hasAutoAddOnBookingEvents"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>

            <div *ngIf="hasAutoAddOnBookingEvents"
                 class="indented-subsection form-group">
              <div class="row">
                <div class="col-md-6 col-12">
                  <label>
                    Auto-Add Event Types
                  </label>
                  <ul class="mb-2 pl-3">
                    <li *ngFor="let eventType of association.auto_add_on_event_booking_types; let idx = index;">
                      {{ eventType.name }}
                      <span *ngIf="eventType.status !== EventTypeStatus.active">
                        ({{ getEventTypeStatusDisplay(eventType.status )}})
                      </span>
                      <a href="#" class="link-danger pl-1"
                         (click)="association.auto_add_on_event_booking_types.splice(idx, 1); unsavedChanges = true; $event.preventDefault();">
                        Remove
                      </a>
                    </li>
                    <li *ngIf="association.auto_add_on_event_booking_types.length === 0"
                        class="text-muted">
                      No event types selected
                    </li>
                  </ul>
                  <a href="#"
                     (click)="openAddAutoAddEventBookingTypeModal();$event.preventDefault();">
                    Select Event Type
                  </a>
                  <div class="form-text text-danger">{{ errors.auto_add_on_event_booking_types }}</div>
                </div>
                <div class="col-md-6 col-12">
                  <label>
                    Auto-Add Event Categories
                  </label>
                  <ul class="mb-2 pl-3">
                    <li *ngFor="let category of association.auto_add_on_event_booking_categories; let idx = index;">
                      {{ category.name }}
                      <a href="#" class="link-danger pl-1"
                         (click)="association.auto_add_on_event_booking_categories.splice(idx, 1); unsavedChanges = true; $event.preventDefault();">
                        Remove
                      </a>
                    </li>
                    <li *ngIf="association.auto_add_on_event_booking_categories.length === 0"
                        class="text-muted">
                      No categories selected
                    </li>
                  </ul>
                  <a href="#"
                     (click)="openAddAutoAddEventBookingCategoryModal();$event.preventDefault();">
                    Select Category
                  </a>
                  <div class="form-text text-danger">{{ errors.auto_add_on_event_booking_categories }}</div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="hasAutoAddOnCheckInEventsSelect">Automatically add customers to this association after they check in to an event</label>
              <select class="custom-select"
                      id="hasAutoAddOnCheckInEventsSelect"
                      name="hasAutoAddOnCheckInEvents"
                      [(ngModel)]="hasAutoAddOnCheckInEvents"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <small class="form-text text-muted">
                For multi-part events, participants will be added to the association when they check in to any single part of the event.
              </small>
            </div>

            <div *ngIf="hasAutoAddOnCheckInEvents"
                 class="indented-subsection form-group">
              <div class="row">
                <div class="col-md-6 col-12">
                  <label>
                    Auto-Add Event Types
                  </label>
                  <ul class="mb-2 pl-3">
                    <li *ngFor="let eventType of association.auto_add_on_event_check_in_types; let idx = index;">
                      {{ eventType.name }}
                      <span *ngIf="eventType.status !== EventTypeStatus.active">
                        ({{ getEventTypeStatusDisplay(eventType.status )}})
                      </span>
                      <a href="#" class="link-danger pl-1"
                         (click)="association.auto_add_on_event_check_in_types.splice(idx, 1); unsavedChanges = true; $event.preventDefault();">
                        Remove
                      </a>
                    </li>
                    <li *ngIf="association.auto_add_on_event_check_in_types.length === 0"
                        class="text-muted">
                      No event types selected
                    </li>
                  </ul>
                  <a href="#"
                     (click)="openAddAutoAddEventCheckInTypeModal();$event.preventDefault();">
                    Select Event Type
                  </a>
                  <div class="form-text text-danger">{{ errors.auto_add_on_event_check_in_types }}</div>
                </div>
                <div class="col-md-6 col-12">
                  <label>
                    Auto-Add Event Categories
                  </label>
                  <ul class="mb-2 pl-3">
                    <li *ngFor="let category of association.auto_add_on_event_check_in_categories; let idx = index;">
                      {{ category.name }}
                      <a href="#" class="link-danger pl-1"
                         (click)="association.auto_add_on_event_check_in_categories.splice(idx, 1); unsavedChanges = true; $event.preventDefault();">
                        Remove
                      </a>
                    </li>
                    <li *ngIf="association.auto_add_on_event_check_in_categories.length === 0"
                        class="text-muted">
                      No categories selected
                    </li>
                  </ul>
                  <a href="#"
                     (click)="openAddAutoAddEventCheckInCategoryModal();$event.preventDefault();">
                    Select Category
                  </a>
                  <div class="form-text text-danger">{{ errors.auto_add_on_event_check_in_categories }}</div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="hasAutoAddEntryPassesSelect">
                Automatically add customers to this association after they check in using an entry pass
              </label>
              <select class="custom-select"
                      id="hasAutoAddEntryPassesSelect"
                      name="hasAutoAddEntryPasses"
                      [(ngModel)]="hasAutoAddEntryPasses"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>

            <div *ngIf="hasAutoAddEntryPasses"
                 class="indented-subsection form-group">
              <div class="form-group">
                <label>
                  Auto-Add Entry Passes
                </label>
                <ul class="mb-2 pl-3">
                  <li *ngFor="let entryPass of association.auto_add_on_entry_pass_use_pass_types; let idx = index;">
                    {{ entryPass.name }}
                    <span *ngIf="entryPass.status !== EntryPassStatus.active">
                      ({{ getEntryPassStatusDisplay(entryPass.status )}})
                    </span>
                    <a href="#" class="link-danger pl-1"
                       (click)="association.auto_add_on_entry_pass_use_pass_types.splice(idx, 1); unsavedChanges = true; $event.preventDefault();">
                      Remove
                    </a>
                  </li>
                  <li *ngIf="association.auto_add_on_entry_pass_use_pass_types.length === 0"
                      class="text-muted">
                    No entry passes selected
                  </li>
                </ul>
                <a href="#"
                   (click)="openAddAutoAddEntryPassModal();$event.preventDefault();">
                  Select Entry Pass
                </a>
                <div class="form-text text-danger">{{ errors.auto_add_on_entry_pass_use_pass_types }}</div>
              </div>

              <label for="auto_add_on_entry_pass_use_only_first">
                Only add if it is the customer's first check-in
              </label>
              <select class="custom-select"
                      id="auto_add_on_entry_pass_use_only_first"
                      name="auto_add_on_entry_pass_use_only_first"
                      [(ngModel)]="association.auto_add_on_entry_pass_use_only_first"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ errors.auto_add_on_entry_pass_use_only_first }}</div>
            </div>

            <div class="form-group">
              <label for="auto_add_on_guest_pass_check_in">
                Automatically add customers to this association after they check in using a guest pass
              </label>
              <select class="custom-select"
                      id="auto_add_on_guest_pass_check_in"
                      name="auto_add_on_guest_pass_check_in"
                      [(ngModel)]="association.auto_add_on_guest_pass_check_in"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ errors.auto_add_on_guest_pass_check_in }}</div>
            </div>

            <div class="indented-subsection form-group"
                 *ngIf="association.auto_add_on_guest_pass_check_in">
              <label for="auto_add_on_guest_pass_check_in_only_first">
                Only add if it is the customer's first check-in
              </label>
              <select class="custom-select"
                      id="auto_add_on_guest_pass_check_in_only_first"
                      name="auto_add_on_guest_pass_check_in_only_first"
                      [(ngModel)]="association.auto_add_on_guest_pass_check_in_only_first"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ errors.auto_add_on_guest_pass_check_in_only_first }}</div>
            </div>

            <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().pos_software === OrgPOSSoftware.square">
              <h3 class="mt-2">Square Customer Groups</h3>

              <div class="alert alert-info">
                In order for a Square customer group to be available for configuration, it must first be enabled as "managed by Capitan" by navigating to
                <a routerLink="/organization-settings" target="_blank">Organization Settings</a>
                and selecting "Manage Customer Groups" in the Integrations section.
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-lg-8 col-md-10">
                    <label for="memberSquareCustomerGroupSelect">
                      "Active Member" Customer Group
                    </label>
                    <div class="float-right mb-1">
                      <a href="#"
                         (click)="$event.preventDefault();resyncSquareCustomerGroups();">
                        Resync Customer Groups
                      </a>
                    </div>
                    <select id="memberSquareCustomerGroupSelectLoading"
                            class="custom-select" name="member_square_customer_group_id"
                            *ngIf="loadingSquareCustomerGroups" disabled>
                      <option>Loading...</option>
                    </select>
                    <select id="memberSquareCustomerGroupSelect"
                            class="custom-select" name="member_square_customer_group_id"
                            *ngIf="!loadingSquareCustomerGroups"
                            [(ngModel)]="association.member_square_customer_group_id"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="null">None</option>
                      <option *ngFor="let squareCustomerGroup of squareCustomerGroupList"
                              [ngValue]="squareCustomerGroup.id">
                        {{ squareCustomerGroup.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this customer group will be assigned in Square to all members of this association.
                  <br>
                  It may take up to 15 minutes to update all existing members when this field is changed.
                </small>
                <div class="form-text text-danger">{{ errors.member_square_customer_group_id }}</div>
              </div>

            </ng-container>

            <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().pos_software === OrgPOSSoftware.lightspeed">
              <h3 class="mt-2">Lightspeed Customer Groups</h3>

              <div class="alert alert-info">
                In order for a Lightspeed customer group to be available for configuration, it must first be enabled as "managed by Capitan" by navigating to
                <a routerLink="/organization-settings" target="_blank">Organization Settings</a>
                and selecting "Manage Customer Groups" in the Integrations section.
              </div>

              <div class="alert alert-info">
                Lightspeed only allows a customer to be assigned to a single group. When a customer qualifies for multiple groups, Capitan will assign the customer to the group with the highest ranking. The group rankings may be updated in
                <a routerLink="/organization-settings">Organization Settings</a>.
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-lg-8 col-md-10">
                    <label for="memberLightspeedCustomerGroupSelect">
                      "Active Member" Customer Group
                    </label>
                    <div class="float-right mb-1">
                      <a href="#"
                         (click)="$event.preventDefault();resyncLightspeedCustomerGroups();">
                        Resync Customer Groups
                      </a>
                    </div>
                    <select id="memberLightspeedCustomerGroupSelectLoading"
                            class="custom-select" name="member_lightspeed_customer_group_id"
                            *ngIf="loadingLightspeedCustomerGroups" disabled>
                      <option>Loading...</option>
                    </select>
                    <select id="memberLightspeedCustomerGroupSelect"
                            class="custom-select" name="member_lightspeed_customer_group_id"
                            *ngIf="!loadingLightspeedCustomerGroups"
                            [(ngModel)]="association.member_lightspeed_customer_group_id"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="null">None</option>
                      <option *ngFor="let lightspeedCustomerGroup of lightspeedCustomerGroupList"
                              [ngValue]="lightspeedCustomerGroup.id">
                        {{ lightspeedCustomerGroup.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this customer group will be assigned in Lightspeed to all members of this association.
                  <br>
                  It may take up to 15 minutes to update all existing members when this field is changed.
                </small>
                <div class="form-text text-danger">{{ errors.member_lightspeed_customer_group_id }}</div>
              </div>

            </ng-container>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>
